import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
export function HeroSection() {
  return <Section className="bg-mint min-h-[75vh] flex items-center pt-16 pb-10" containerClass="text-center" data-id="element-97">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-0" data-id="element-98">
        <svg className="relative block w-full h-[150px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-99">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-white opacity-40" data-id="element-100"></path>
        </svg>
      </div>

      {/* Balloon Cluster Top */}
      <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 flex justify-center w-full max-w-3xl z-0 opacity-80" data-id="element-101">
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 4,
        ease: 'easeInOut'
      }} className="w-32 h-32 bg-partyPink rounded-full mx-[-20px] shadow-soft mt-10" data-id="element-102"></motion.div>
        <motion.div animate={{
        y: [0, -15, 0]
      }} transition={{
        repeat: Infinity,
        duration: 5,
        ease: 'easeInOut',
        delay: 0.5
      }} className="w-40 h-40 bg-coral rounded-full mx-[-20px] shadow-soft" data-id="element-103"></motion.div>
        <motion.div animate={{
        y: [0, -8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 3.5,
        ease: 'easeInOut',
        delay: 1
      }} className="w-36 h-36 bg-yellow-party rounded-full mx-[-20px] shadow-soft mt-4" data-id="element-104"></motion.div>
        <motion.div animate={{
        y: [0, -12, 0]
      }} transition={{
        repeat: Infinity,
        duration: 4.5,
        ease: 'easeInOut',
        delay: 0.2
      }} className="w-44 h-44 bg-mint-dark rounded-full mx-[-20px] shadow-soft -mt-4" data-id="element-105"></motion.div>
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 4,
        ease: 'easeInOut',
        delay: 0.8
      }} className="w-32 h-32 bg-partyPink-dark rounded-full mx-[-20px] shadow-soft mt-12" data-id="element-106"></motion.div>
      </div>

      {/* Confetti / Stars */}
      <div className="absolute top-1/4 left-10 text-4xl text-white opacity-60 animate-pulse" data-id="element-107">
        ✨
      </div>
      <div className="absolute top-1/3 right-20 text-5xl text-yellow-party opacity-70 animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-108">
        ✨
      </div>
      <div className="absolute bottom-1/4 left-1/4 text-3xl text-partyPink-hot opacity-50 animate-pulse" style={{
      animationDelay: '0.5s'
    }} data-id="element-109">
        ✨
      </div>

      <div className="relative z-10 bg-white/90 backdrop-blur-sm p-8 md:p-12 rounded-3xl shadow-xl max-w-4xl mx-auto mt-20 border-4 border-white" data-id="element-110">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-111">
          <h2 className="text-partyPink-hot font-script text-3xl md:text-5xl mb-2 transform -rotate-2" data-id="element-112">
            Crea la mejor
          </h2>
          <h1 className="text-5xl md:text-7xl font-black text-mint-dark uppercase tracking-tight mb-4 drop-shadow-sm" data-id="element-113">
            fiesta para <span className="text-coral" data-id="element-114">tu peque!</span>
          </h1>
          <h3 className="text-2xl md:text-4xl font-script text-gray-600 mb-8 transform rotate-1" data-id="element-115">
            la magia comienza aquí
          </h3>
        </motion.div>

        {/* Hero Image */}
        <div className="relative w-full max-w-2xl mx-auto h-64 md:h-80 rounded-2xl mb-8 overflow-hidden shadow-lg group" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/jWCr1Co36gXbbfhcSzwQKM/Anadir_un_titulo.png" alt="Fiestas temáticas decoradas con globos y personajes" className="w-full h-full object-cover" data-id="element-117" />

          {/* Decorative badge */}
          <div className="absolute -right-4 -top-4 w-24 h-24 bg-yellow-party rounded-full flex items-center justify-center shadow-lg transform rotate-12 z-20" data-id="element-118">
            <span className="text-center font-bold text-coral leading-tight text-sm" data-id="element-119">
              ¡INCLUYE
              <br data-id="element-120" />
              TODO!
            </span>
          </div>
        </div>

        <p className="text-lg md:text-xl text-gray-700 mb-10 max-w-2xl mx-auto font-medium" data-id="element-121">
          Diseños listos para personalizar, descargar, imprimir y montar en casa
          <span className="font-bold text-partyPink-hot" data-id="element-122">
            {' '}
            incluso si no eres creativa y tienes poco tiempo!
          </span>
        </p>

        <Button size="lg" className="animate-bounce hover:animate-none" data-id="element-123">
          ¡QUIERO MI KIT AHORA!
        </Button>
      </div>

      {/* Bottom Bunting/Garland Decoration */}
      <div className="absolute bottom-0 left-0 w-full h-16 flex justify-around items-end overflow-hidden z-20" data-id="element-124">
        {[...Array(15)].map((_, i) => <div key={i} className={`w-0 h-0 border-l-[30px] border-l-transparent border-r-[30px] border-r-transparent border-t-[40px] ${i % 3 === 0 ? 'border-t-partyPink' : i % 3 === 1 ? 'border-t-mint-dark' : 'border-t-yellow-party'} transform origin-top ${i % 2 === 0 ? 'rotate-[-5deg]' : 'rotate-[5deg]'}`} data-id="element-125"></div>)}
      </div>
    </Section>;
}